var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 4V17.5M15 6V20.5M15.503 20.748L20.378 18.311C20.759 18.121 21 17.731 21 17.305V4.82001C21 3.98401 20.12 3.44001 19.372 3.81401L15.503 5.74801C15.186 5.90701 14.813 5.90701 14.497 5.74801L9.503 3.25201C9.34682 3.17394 9.17461 3.1333 9 3.1333C8.82539 3.1333 8.65318 3.17394 8.497 3.25201L3.622 5.68901C3.24 5.88001 3 6.27001 3 6.69501V19.18C3 20.016 3.88 20.56 4.628 20.186L8.497 18.252C8.814 18.093 9.187 18.093 9.503 18.252L14.497 20.749C14.814 20.907 15.187 20.907 15.503 20.749V20.748Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIcon);
export default __webpack_public_path__ + "static/media/NavigationIcon.f09d196aa58d7422a668631ebe4d41c8.svg";
export { ForwardRef as ReactComponent };